import React from 'react';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import style from './style.module.scss';

export interface OverviewToolbarProps {
    editMode?: boolean;
    /** When omitted, the Edit/Done toggle is not rendered (e.g. the RPP dashboard). */
    onToggle?: () => void;
    /** Page-level filters. Rendered at the left edge of the row. */
    filters?: React.ReactNode;
}

/**
 * Toolbar row above the KPI card grid: the page filters at the left edge, the
 * optional Edit/Done toggle at the far right (rendered only when `onToggle` is
 * provided).
 *
 * The filters used to sit in the right-hand group, with an empty div holding
 * the left edge open. That is what made them impossible to left-anchor from
 * inside `AnalyticsSearchOptions`: whatever the filters did to their own
 * alignment, the group holding them was still being pushed right by the row's
 * `space-between`.
 */
export const OverviewToolbar: React.FC<OverviewToolbarProps> = ({
    editMode = false,
    onToggle,
    filters,
}) => {
    return (
        <div className={style.toolbar}>
            <div className={style.toolbar_left}>{filters}</div>
            <div className={style.toolbar_right}>
                {onToggle && (
                    <Button
                        type={editMode ? 'primary' : 'default'}
                        icon={<EditOutlined />}
                        onClick={onToggle}
                        aria-pressed={editMode}
                    >
                        {editMode ? 'Done' : 'Edit'}
                    </Button>
                )}
            </div>
        </div>
    );
};
